module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Sybil Woolmore, the youngest of six siblings, was born in Auckland and raised on a remote sheep and cattle farm on the west coast of the North Island of New Zealand. She has always been a very independent person having been sent off to boarding school at aged 13 and then going flatting straight from school. She had no children but inherited two wonderful step children.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("She enjoyed art for many years, selling several paintings and it wasn’t until they retired and moved to Paeroa from Auckland seven years ago that she started writing and joined a newly formed writing group. She is inspired by life and people around her.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0